import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { OnboardingChecklistStatus } from "~/features/onboarding-checklist/types";
import { useApiClient } from "~/hooks/use-api-client";
import type { UserDetailsData } from "~/modules.server/profile/user-details-service";

export function useCloseOnboardingChecklist() {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            const response = await apiClient.post(
                "/practitioner/onboarding-checklist",
                { intent: "close" },
            );

            if (!response.ok) {
                throw new Error("Failed to close onboarding checklist");
            }

            return (await response.json()) as OnboardingChecklistStatus;
        },
        onSuccess: (status) => {
            queryClient.setQueryData<UserDetailsData>(["user"], (old) =>
                old ? { ...old, onboardingChecklist: status } : old,
            );
            void queryClient.invalidateQueries({ queryKey: ["user"] });
        },
    });
}
